import formatFileSize from './utils'

const messages = {
  _default: () => `non è valido.`,
  after: (field, [target]) => `deve trovarsi dopo ${target}.`,
  alpha_dash: () =>
    `può contenere caratteri alfanumerici come pure trattini e underscore.`,
  alpha_num: () => `può contenere solo caratteri alfanumerici.`,
  alpha: () => `può contenere solo caratteri alfabetici.`,
  before: (field, [target]) => `deve trovarsi davanti a ${target}.`,
  between: (field, [min, max]) => `deve essere compreso fra ${min} e ${max}.`,
  confirmed: (field, [confirmedField]) =>
    `passt nicht zum Inhalt von ${confirmedField}.`,
  date_between: (field, [min, max]) =>
    `deve essere compreso fra ${min} e ${max}.`,
  date_format: (field, [format]) => `deve avere il formato ${format}.`,
  decimal: (field, [decimals = '*'] = []) =>
    `deve essere numerico e può contenere ${decimals === '*' ? '' : decimals
    } punti decimali.`,
  digits: (field, [length]) =>
    `deve essere numerico e contenere esattamente ${length} cifre.`,
  dimensions: (field, [width, height]) =>
    `deve avere una dimensione di ${width} x ${height} pixel.`,
  email: () => `deve essere un indirizzo e-mail valido.`,
  ext: () => `deve essere un file valido.`,
  image: () => `deve essere una grafica.`,
  in: () => `deve essere un valore valido.`,
  ip: () => `deve essere un indirizzo IP valido.`,
  max: (field, [length]) => `non deve essere più lungo di ${length} caratteri.`,
  mimes: () => `deve avere un tipo di file valido.`,
  min: (field, [length]) => `deve essere lungo almeno ${length} caratteri.`,
  not_in: () => `deve essere un valore valido.`,
  numeric: () => `può contenere solo caratteri numerici.`,
  regex: () => `Il formato di non è valido.`,
  required: () => `è un campo obbligatorio.`,
  size: (field, [size]) => `deve essere più piccolo di ${formatFileSize(size)}.`,
  url: () => `non è un URL valido.`,
  fullName: () => 'non è valido (cognome, nome e max 120 caratteri)',
  emailInput: () => `deve essere un indirizzo e-mail valido.`,
  fullNamePerCountry: () => 'non è valido (cognome, nome e max 18 caratteri)',
  invalidCharPerCountry: () => 'is not valid (contains invalid characters)',
  orderNumberPerCountry: () => `è troppo lungo`,
  blackListZipCodePerCountry: () => 'code is not allowed!'
}

const locale = {
  name: 'it',
  messages,
  attributes: {}
}

export default locale



// WEBPACK FOOTER //
// ./client/translations/vee-validate/it.js